import React from 'react';
import { Info } from 'lucide-react';

export function CampaignLimitsBanner({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div
      role="note"
      aria-label="Campaign task limits"
      className="my-4 flex items-start gap-2 rounded-lg border border-blue-100 bg-blue-50 px-4 py-3 text-sm text-blue-900"
    >
      <Info aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0" />
      <p>{message}</p>
    </div>
  );
}
